module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "div_intro"
  }, [_c('div', {
    staticClass: "pre",
    attrs: {
      "id": "pre-004"
    }
  }, [_c('h1', {
    staticClass: "pre_tit"
  }, [_c('span', [_vm._v("Introduction")])]), _vm._v(" "), _c('div', {
    staticClass: "dev"
  }, [_c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-003"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("I. Title and contents")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Numbers is the English translation of the Greek title of the book "), _c('i', [_vm._v("Arithmoi")]), _vm._v(", a title no doubt given to it because of the census returns found in chapters 1 – 4 and 26. The fifth word of the book, "), _c('i', [_vm._v("bĕmidbar ")]), _vm._v("‘in the wilderness’, constitutes its Hebrew title. This more aptly describes its contents, for it is wholly concerned with the forty years the tribes of Israel spent wandering in the wilderness between Mount Sinai and the plains of Moab.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Numbers begins with a series of directions organizing the people to march from Sinai to the promised land. The tribes are counted, their arrangement in the camp and on the march is specified, the unclean are expelled from the community, the altar and the Levites are dedicated to the service of God, and a second passover is celebrated. The nation is now ready to begin the advance towards Canaan (1:1 – 10:10). Twenty days later the journey begins, difficulties are encountered on the way, but Kadesh on the borders of "), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("Canaan is safely reached (10:11 – 12:16). From Kadesh twelve spies are sent out to inspect the land. Their report is so discouraging that the people propose returning to Egypt (13:1 – 14:4). God then threatens to annihilate the nation, but is persuaded by Moses’ intercession to commute the sentence to forty years’ wandering in the wilderness.")])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Chapter 15 contains laws about cereal offerings, libations, high-handed sins, and tassels on garments. Chapters 16 – 17 relate several rebellions against the prerogatives of the priests and Levites. Chapter 18 sets out the offerings they are to receive and chapter 19 the rules about purification after death.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In chapters 20 – 21, after an interval of nearly forty years, the movement towards the land resumes with conquests over Canaanites in the Negeb and Amorites in Transjordan.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The rest of the book (chapters 22 – 36) relates what happened to Israel as they waited to cross the Jordan opposite the city of Jericho. These chapters include Balaam’s prophecies about Israel’s future (22 – 24), idolatry at Baal Peor (25), another census (26), laws about land, festivals and vows (27 – 30). The defeat of the Midianites and the request of the tribes of Gad, Reuben and Manassch to settle in Transjordan are the subject of 31 – 32. Finally there is the list of places at which Israel camped (33) and a group of laws dealing with the distribution of the promised land (34 – 36).")])])]), _c('a', {
    attrs: {
      "id": "page_16"
    }
  }), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-004"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("2. Structure")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("This brief summary of the contents of Numbers highlights one of the gravest problems it poses for commentators: how is the order, or disorder, of the material to be explained? Is there any reason for the apparently random juxtaposition of law and narrative, which makes Numbers look like ‘the junk room of the priestly code’? Most commentators offer no explanation except a source-critical one, suggesting that the laws come from a priestly source (P) whereas the narratives are for the most part derived from the epic JE traditions. That Numbers contains various sources is obvious, but this does not solve the mystery of the editor’s method. Why should he have arranged his source material as he did, when the material itself shows he was a person deeply concerned with order and organization?")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_16"
    }
  }, [_vm._v("De Vaulx suggests that the mixture of law and narrative enables ")]), _c('a', {
    attrs: {
      "id": "page_17"
    }
  }, [_vm._v("the editor to put over the idea that ‘the saving history and the law are not simply past events, but that they are always contemporary. The successive redactors of stories and laws all remind their contemporaries that the saving history concerns everyone and that it is today that they must do the will of God.’")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP1",
      "id": "ap_NBP1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" In his commentary he endeavours to show that there is a coherence between the theme of the laws and the narratives: both are concerned with the nation’s journey towards Canaan. The laws prescribe how Israel is to travel organized as the holy army of God to the land of promise, and what they are to do when they arrive there (cf. 1 – 10, 28 – 30, 34 – 36), while the narratives describe the twists and turns in the journey (11 – 14, 20 – 21). This analysis is basically correct, though it does leave certain features in the centre of the book (e.g. chapter 15 and the Balaam episode) unexplained. More detailed study suggests a motive for the inclusion and position of much of this other material. Throughout the Pentateuch chronological notices divide the material into large cycles of narrative or blocks of law. Shorter units are indicated by inclusion, that is, by the repetition at the end of a section of a sentence or phrase with which it began, and by the three-fold groupings of laws and narratives. All these devices are used in Numbers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP2",
      "id": "ap_NBP2-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Another principle explains the position of certain laws at apparently inappropriate points in the narrative. The promulgation of a law carries with it the implication that God will put Israel into a situation where she can fulfil the law. Thus laws can function as promises. The clearest example of this is to be found in chapter 15, where the demand to offer grain, oil and wine along with animal sacrifice is an implicit pledge that one day Israel will enter Canaan despite the events described in the previous chapters 13 – 14. The six laws about the land (33:50 to the end) similarly remind the reader that the promise is on the verge of fulfilment.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Much the most important principle in the arrangement of the "), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("book of Numbers is its use of rondo form, or perhaps more exactly variation form. It is cast in large cycles in which three important eras of revelation, at Sinai, Kadesh, and in the plains of Moab, are separated by two bridge passages describing the journeys from Sinai to Kadesh, and from Kadesh to the plains of Moab. Theologically these cycles exemplify the principle of typology: history repeats itself, with variation of course, because it is based on two factors which do not change: God’s character and man’s sinfulness. Though Numbers like other parts of the Bible")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP3",
      "id": "ap_NBP3-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" does present history as cyclical, there is a development within each cycle, and it is by comparing each cycle with the preceding one that the full significance of the later phase becomes apparent. If typology determines the overall structure of the book, we should also note that it also underlines the threefold grouping of the murmuring stories in chapters 11 – 12, 16 – 17 and the Balaam narrative in chapters 22 – 24, as well as the sixfold pattern of encampments in chapter 33.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The material in Numbers cannot be understood apart from what precedes it in Exodus and Leviticus. The three middle books of the Pentateuch hang closely together, with Genesis forming the prologue, and Deuteronomy the epilogue to the collection. Diagrammatically the material in Exodus to Numbers may be represented as follows:")]), _vm._v(" "), _c('div', {
    staticClass: "fig",
    attrs: {
      "id": "fig_p18"
    }
  }, [_c('div', {
    staticClass: "imagelarge"
  }, [_c('img', {
    staticClass: "imagelarge",
    attrs: {
      "alt": "image",
      "src": "images/fig_p18.jpg"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Exodus to Numbers thus falls into three cycles, of which the second and third belong entirely to Numbers. The material in the later cycles does not repeat that found in the first in any mechanical way. In particular the episodes in Exodus 1 – 13 are of a markedly different character from the later periods of dramatic revelation associated with Sinai, Kadesh and the plains of Moab. But from Exodus 13:17 the recurrence of similar topics and motifs at the same point "), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("in the cycle seems more than coincidental. This impression is confirmed by explicit allusions to the previous occasions in the stories themselves (e.g. Num. 28:6; 32:8ff.). The synopses below bring out the parallels between the three journeys, and between the three occasions of law-giving, at Sinai, Kadesh and the plains of Moab. By definition it overlooks the differences between the three cycles, which are exegetically at least as important as the similarities. The reader is expected to compare and contrast the nation’s behaviour on the different occasions.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-004"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('b', [_vm._v("Journeys")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "4",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "25%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "colspan": "2",
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('b', [_vm._v("Red Sea to Sinai")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('b', [_vm._v("Sinai to Kadesh")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('b', [_vm._v("Kadesh to Moa")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Led by cloud")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Exod. 13:21")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("= Num. 10:11ff.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Victory over Egypt")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("14")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("cf. "), _c('i', [_vm._v("21:21–35")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Victory song")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("15:1–18")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("cf. "), _c('i', [_vm._v("10:35f.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("21:14–15")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Miriam")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("15:20–21")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("= 12")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("= 20:1")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("People complain")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("15:23–24")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("= 11:1")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("= 21:5")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Moses’ intercession")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("15:25")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("= 11:2")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("= 21:7")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Well")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("15:27")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("= 21:16")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Manna and quails")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("16")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("= 11:4–35")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Water from rock")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("17:1–17")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("= 20:2–13")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Victory over Amalek")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("17:8–16")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("cf. "), _c('i', [_vm._v("21:1–3")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Jethro")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("18:1–12")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("cf. "), _c('i', [_vm._v("10:29–32")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "tableau",
    attrs: {
      "id": "tab-005"
    }
  }, [_c('div', {
    staticClass: "tabtit"
  }, [_c('p', {
    staticClass: "txt_courant_centre"
  }, [_c('b', [_vm._v("Stops")])])]), _vm._v(" "), _c('div', {
    staticClass: "table-align"
  }, [_c('table', {
    attrs: {
      "border": "1",
      "cellpadding": "4",
      "cellspacing": "0"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "23%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "23%"
    }
  }), _vm._v(" "), _c('col')]), _vm._v(" "), _c('tbody', [_c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('b', [_vm._v("Topic")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('b', [_vm._v("Sinai")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('b', [_vm._v("Kadesh")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('b', [_vm._v("Moab")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Divine promises")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Exod. 19:5-6; 23:23ff.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Num. 13:2")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("22 –24")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("40 days")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("24:18")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("13:25")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("–")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Rebellion")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("32:1–8")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("14:1ff.")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("25:1–3")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Moses’ intercession")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("32:11–13")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("14:13–19")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("–")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Judgment")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("32:34")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("14:20–35")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("25:4")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Plague")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("32:35")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("14:37")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("25:8–9")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Laws of sacrifice")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("34:18ff.; Lev.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("1 – 7. etc.")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("15:1–31")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("28 – 29")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Trial")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Lev. 24:10–23")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("15:32–36")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("27:1–11")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Rebellion against priests")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Lev. 10:1–3")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("16:1–35")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("–")])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Atonement through priests or Levites")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Exod.")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("32:26–29")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("16:36–50")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("25:7–13")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Priestly prerogatives")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Lev. 6 – 7; 22")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("17 – 18")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("31:28–30")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("35:1–8")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Impurity rules")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Lev. 11–16;")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Num. 9:6–14")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("19")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("31; 35:9ff.")])])])]), _vm._v(" "), _c('tr', {
    attrs: {
      "valign": "top"
    }
  }, [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("Census")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("Num. 1 – 4")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_vm._v("–")])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justify"
  }, [_c('i', [_vm._v("26")])])])])])])])])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("Some of the correspondences between the cycles have long been recognized by commentators, e.g. the two stories about water from the rock (Exod. 17:1–7 // Num. 20:2–13); but the overall arrangement of the material in three extended cycles has not been noted hitherto. It is not however unique. Deuteronomy is based on three ")]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_vm._v("long speeches by Moses (1 – 4, 5 – 28, 29 – 30). An even closer parallel is provided by the book of Genesis. The three major cycles about the patriarchs, Abraham, Jacob and Joseph, are each introduced by the formula ‘These are the generations of Terah, (Isaac, Jacob)’ (Gen. 11:27; 25:19; 37:2), and interrupted by shorter blocks of material introduced by the same formula (25:12; 36:1). The primeval history (Gen. 2 – 11) follows a similar pattern; narrative (2:4 – 4:26), genealogy (5:1 – 6:8), narrative (6:9 – 9:28), genealogy (10:1–32), narrative (11:1–9), genealogy (11:10–26). Except in 11:1, each section again begins with the formula ‘These are the generations of ’.")])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("These parallels with Numbers suggest that casting material in triadic form was an established literary device for the biblical writers. It does not mean that they have distorted the record by using what seems to us a rather contrived form. All history writing involves selection (cf. John 20:30–31; 21:25) if any sense is to be made of the past. The Bible focuses our attention on events of theological significance, first by recording them, and second by setting them in a context which conveys their meaning. Though its methods may not be those of modern critical historians, neither ancient nor modern methods of history writing necessarily involve creating facts or being untruthful. The honesty of the biblical records is attested by their inclusion of much material that does not fit the cyclical scheme exactly: the traditions they inherited had to be handed on faithfully even where they were inconvenient from a purely literary standpoint.")])])]), _c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-005"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("3. Sources")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("The ultimate source of most of the material in Numbers is divine. Nearly every section begins ‘The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(" spoke to Moses’ or with some similar remark. But to determine how the inspired words were preserved and passed on prior to their incorporation in the Pentateuch is much more difficult and has occasioned warm controversy. This is partly because there are so few statements within the Pentateuch about the sources which its editor or editors used in compiling the book, and partly because much of the material it contains supposedly reflects conditions a long time after the Mosaic period.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_21"
    }
  }), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Explicit indications of sources are rare in Numbers. 33:2 states that ‘Moses wrote down their starting places’, evidently implying that a Mosaic document was used to compile the list of Israelite encampments found in this chapter. 21:14–15 contains a quotation from the Book of the Wars of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", an otherwise unknown document, usually supposed to consist of poetry.")])]), _c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Especially striking is the inclusion in Numbers of material that is expressly attributed to non-Israelites. There is the Amorite song recounting their victory over the Moabites (21:27–30), and the oracles of Balaam, the Mesopotamian seer hired by the Moabites and Midianites to curse Israel (23 – 24). How such material came into Israelite hands must remain conjectural. It is possible that captured Amorites or Moabites reported these sayings to their conquerors, but this is only surmise.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("According to the most widely received critical theory, there are four major sources in Numbers: J the Yahwistic source, E the Elohistic source, P the Priestly source and P"), _c('sub', [_vm._v("s")]), _vm._v(", a supplement to the Priestly source. In many passages scholars who believe in these sources confess themselves uncertain whether the material is to be assigned to J or E. A similar uncertainty surrounds the differentiation of P and P"), _c('sub', [_vm._v("s")]), _vm._v("; but there is a wide measure of agreement on the distinction between the epic JE material on the one hand and the priestly (P and P"), _c('sub', [_vm._v("s")]), _vm._v(") material on the other. The legal material and narratives illustrating legal points are assigned to P, whereas pure narratives are ascribed to JE.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("According to Gray, who presents the arguments for this type of analysis most judiciously, the following passages belong to J or E:")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("10:29 – 12:15; 13:17b–20, 22–24, 26–33; 14:1b, 3–4, 8–9, 11–25, 39–45;")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("16:1b, 2b, 12–15, 25–26, 27b–34; 20:1b, 5, 14–21; 21:1–9, 11b–32;")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_vm._v("22:2 – 25:5; 32(?); 33(?).")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In chapters 32 and 33 Gray believes both JE and P are present, but he does not think they can be disentangled convincingly. The rest of the material Gray assigns to P, P"), _c('sub', [_vm._v("s ")]), _vm._v("or editors.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_22"
    }
  }, [_vm._v("Three main arguments are put forward in favour of this documentary analysis. First, it is argued that the diversity of the material in Numbers is best explained by the presence of several sources. ")]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("Secondly, the existence of the documents JE and P in Genesis and Exodus makes it probable that they continue in Numbers. Thirdly, the laws and traditions show evidence of having originated in different periods. This last argument will be considered in more detail in the next section ‘Date and authorship’. Here I shall concentrate on the other two arguments.")])]), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The argument from diversity of subject-matter proves little about sources. Indeed once the plan of Numbers is grasped, the mixture of law and narrative is less suggestive of multiple sources. Nor does the diversity of style necessarily prove the book had several authors. If I had to draft a law, I should adopt a very different style and vocabulary from that used in commentary writing. Poets can also write prose, but again their syntax, style and vocabulary will vary as the form of their writing dictates. The style and vocabulary of the narrative sections of Numbers will therefore inevitably differ from the cultic laws in the book: such differences are a function of the subject-matter.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_23"
    }
  }, [_vm._v("To prove the existence of different sources it is necessary to compare like with like, cultic laws with cultic laws and narrative with narrative, and utilize the minutest points of morphology and syntax to demonstrate diversity or homogeneity of authorship.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP4",
      "id": "ap_NBP4-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")])]), _vm._v(" The crude vocabulary counts used in traditional source criticism do not demonstrate diversity of source, only diversity of subject-matter. Until such refined techniques are used in pentateuchal studies one can still talk of priestly (P) material or epic material (JE) in Numbers, as long as it is not asserted that this material must necessarily derive from different sources or authors.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("If it is accepted that Genesis is composed of J, E and P, it is natural to suppose that the same sources continue into Numbers. However, it is universally admitted that the clearest criteria for distinguishing sources in Genesis do not apply in Numbers. For example the divine name criterion (Yahweh = J, Elohim = P or E) does not serve to distinguish between the sources after Exodus 6. And real "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }, [_vm._v("doublets, that is duplicate narratives or laws, are rare in Numbers, and even some of the most plausible cases are not regarded as proof of diverse origin by source critics.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP5",
      "id": "ap_NBP5-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The source analyses of those stories which are split between J and E (e.g. Balaam 22 – 24) or between JE and P (the spies (13–14), Korah, Dathan and Abiram (16) prove equally dubious. They are dealt with in more detail at the appropriate point in the commentary. There it is shown that the supposedly early version of the stories (JE) presupposes elements found only in later versions (P or P"), _c('sub', [_vm._v("s")]), _vm._v("), and it is argued that division into sources spoils the literary design of these tales. Finally, the way chapter 33 brings together elements from the travelogues of JE and P speaks against assigning the travel notes to different sources, if the integrity and antiquity of Numbers 33 is admitted."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP6",
      "id": "ap_NBP6-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Were it not assumed by commentators on Numbers that J, E and P had been shown to be continuous documents in Genesis, they would have looked for alternative critical hypotheses to explain the phenomena in Numbers more economically. Recently it has been argued that Genesis has been composed by bringing together large blocks of material, e.g. the stories of Abraham, the primeval history, and joining them end to end."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP7",
      "id": "ap_NBP7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" (The classical documentary theory sees the main sources as long strands, each containing a little bit about each topic, creation, flood, Abraham, etc., which have been knitted together to form the present narrative.) The structure of Numbers outlined above lends itself to the type of analysis proposed by Rendtorff for Genesis. Thus we may think of an editor bringing together a block of material dealing with Kadesh, a block dealing with the plains of Moab and linking them to the Sinai material using short travelogues. This would avoid splitting up well-constructed "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("units within these blocks (the spies, Balaam) into contradictory sources.")])]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-006"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("4. Date and authorship")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_25"
    }
  }, [_vm._v("Traditionally it was held that Moses was the author of the entire Pentateuch except for the account of his death in Deuteronomy 34. This would mean it was composed in either the middle of the thirteenth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" or in the late fifteenth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(".")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP8",
      "id": "ap_NBP8-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")])]), _vm._v(" The chief arguments in favour of this view are statements within the Pentateuch that Moses did write some of it down (Exod. 24:4; Num. 33:2; Deut. 31:9, 22), the constant claim that the laws were revealed to him (Exod. 25:1; Lev. 1:1; Num. 1:1, etc.), and the assumption by the New Testament of Mosaic authorship (Matt. 8:4; 19:7; Luke 24:44; John 1:45).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Towards the end of the last century an entirely different view of the composition of the Pentateuch came into vogue. The analysis of the material into the sources J, E, D and P was combined with dating them long after Moses. Nowadays J is customarily dated to the tenth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(", E to the ninth, P to the sixth and P"), _c('sub', [_vm._v("s ")]), _vm._v("later still. There is thus an immense gap between these sources and the time of Moses. It is admitted that JE may contain some old traditions reaching back to Mosaic times, but P is regarded very much as an idealization of the past, not a reliable historical record. Its laws and institutions are held to reflect the much later period in which it was written, not the Mosaic period. Numbers in particular is therefore considered a mixture of the relatively early J and E sources and the very much later P and P"), _c('sub', [_vm._v("s ")]), _vm._v("sources. These various sources were combined by a succession of editors, the last of whom worked in about the fifth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_26"
    }
  }, [_vm._v("Full discussion of the various theories will be found in Introductions to the Old Testament.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP9",
      "id": "ap_NBP9-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])]), _vm._v(" Here it must suffice to indicate some of the chief objections to the late dating of the P material in Numbers. The case for a late date of P depends on a hypothetical reconstruction of the history of Israelite religion, that is at odds with what the Bible itself asserts about that history. Were it not for our age’s philosophical romanticism, which views the supposed unfettered freedom of JE as a primary early and positive manifestation of the human spirit, and the law-bound rituals of P as a later and less desirable development, it is doubtful whether an exilic or post-exilic date for P would have become so widely accepted, for such a dating raises major problems. For example, in post-exilic times the ratio of priests to Levities was 12:1 (Ezra 2:36ff.; cf. 8:15), whereas the tithe law in Numbers 18:26 implies a ratio of priests to Levites of 1:10. Other institutions such as the ark, the anointing of the high priest, the Urim and Thummim, so important in the P material, had also disappeared in the post-exilic era."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP10",
      "id": "ap_NBP10-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("If this were the only evidence for the early origin of P, it might be put down to the reliability of its tradition. Other data cannot be so easily explained this way. For example, much of the technical terminology of P became obsolete after the seventh century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(": the books of Chronicles, Ezra and Nehemiah use different terms for the same concepts as P discusses, while the book of Ezekiel (7th/sixth century) stands linguistically between P and Ezra in its usage."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP11",
      "id": "ap_NBP11-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A comparison with Ezekiel is instructive in other ways. Ezekiel quotes from and alludes to the book of Leviticus a great deal,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP12",
      "id": "ap_NBP12-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")])]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }, [_vm._v("especially the laws in Leviticus 18 – 26. But he also uses Numbers 34 to describe the limits of the new promised land, and Numbers 35:1–8 is the basis of his conception of the priestly and levitical land around Jerusalem. But whereas Numbers 35 thinks of villages of Levites scattered throughout the land, Ezekiel envisages long strips of land adjacent to Jerusalem inhabited by priests or Levites. The programme of Numbers is a practical one, but Ezekiel’s is that of an utopian visionary.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP13",
      "id": "ap_NBP13-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Similarly Deuteronomy, dated by no-one much later than the seventh century, shows great familiarity with the contents of Numbers."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP14",
      "id": "ap_NBP14-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" It is important to note that it is not merely to the JE parts of Numbers that Deuteronomy alludes, Miriam’s leprosy (Num. 12; Deut. 24:9), the journeys of Israel (20:14 – 21:20; Deut. 2:1–25), the conquest of Transjordan (21:21–35; Deut. 2:26 – 3:10), Balaam (22 – 24; Deut. 23:4–5), but also to material found only in P, the laws on priestly dues (18; Deut. 18:2), the incident at Meribah Kadesh (20:12; Deut. 32:51–52), vows (30; Deut. 23:21–23) and the cities of refuge (35:9–34; Deut. 19:1–13). In episodes split between JE and P (e.g. the spy story, the settlement of the two and a half tribes in Transjordan), Deuteronomy is aware of details found in both P and JE (13 – 14; 31; Deut. 1:19–46; 3:12–29). This suggests that all of Numbers is prior to Deuteronomy. And if JE and P are no longer to be regarded as originating in widely different periods of history, a reformulation of the source analysis along the lines suggested in the previous section no longer presents great difficulties.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Comparison of Numbers with other Old Testament books permits only a relative not an absolute dating, as long as the date of these other books is disputed. Rendtorff has rightly underlined the uncertainty of most critical discussion of these issues. ‘We possess hardly any reliable criteria for dating pentateuchal literature. Every "), _c('a', {
    attrs: {
      "id": "page_28"
    }
  }, [_vm._v("dating of the pentateuchal “sources” rests on purely hypothetical assumptions, which only have any standing through the consensus of scholars.’")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP15",
      "id": "ap_NBP15-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")])]), _vm._v(" Such candour from one of the most eminent scholars in the field of pentateuchal criticism is noteworthy. If he is right, one could date almost any part of the Pentateuch to any period between the time of Moses and the time of Ezekiel.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("There are some pointers in Numbers that its contents should probably be dated early within this broad period. Parallels to the census lists (Num. 1 and 26) are found in the Mari texts (eighteenth century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(") from Mesopotamia, in old kingdom Egyptian documents, and in classical sources. The names of the tribal leaders (1:5–15) are characteristically second millennium in form. So was their mode of encampment. The tribes of Israel camped in a square with the tent of their divine king at the centre (Num. 2). This arrangement was followed by Rameses II (thirteenth century) on his campaigns, whereas first-millennium Assyrian royal tent enclosures were circular. The role of the priests and Levites guarding the tabernacle (Num. 4) finds parallels in Hittite texts.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The design of the lampstand (Num. 8) shows it comes from the Late Bronze Age (15th to 13th centuries). Trumpets were used in the Egyptian new kingdom to summon to war and worship (Num. 10). Tasselled garments (Num. 15) are attested among Israel’s neighbours from the mid-second millennium onwards. In style and form the letter to Edom (Num. 20) resembles second-millennium diplomatic notes. A bronze serpent (Num. 21) and a tent shrine used by Midianites in the twelfth century have been found at Timna. The content and language of the Balaam oracles and the other poems in Numbers suggest an early date of composition and their committal to writing no later than the early monarchy period. The laws on sacrifice in Num. 28 – 29 resemble a forteenth-century ritual calendar from Ugarit. Finally, the boundaries of Canaan as defined in Numbers 34 correspond to those of the Egyptian province of Canaan in texts of the 15th to 13th centuries "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This evidence lends weight to the book’s own testimony that the traditions on which it is based originated in the Mosaic period. How much expansion, revision and rewriting they underwent in the "), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("centuries before they reached their final form, possibly in the early days of the monarchy, is hard to determine by critical methods. It is perhaps fairer to give the tradition the benefit of the doubt, than to assume everything must be late unless there is evidence to the contrary. But precise dating of the material is largely irrelevant to exegesis, for it is the final form of the text that has canonical authority for the church, and that is the focus of interest in the chapters that follow.")])]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-007"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("5. The Hebrew text of Numbers")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("All modern English translations of Numbers are based on the Massoretic Text ("), _c('span', {
    staticClass: "small"
  }, [_vm._v("MT")]), _vm._v("), that is Hebrew manuscripts of the Old Testament produced in the tenth century AD. Fragments of Numbers from caves by the Dead Sea (6 from Qumran and 2 from Murabaat) show that the Hebrew text of the book was preserved very carefully in the thousand years preceding the production of the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MT")]), _vm._v(".")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }, [_vm._v("The Dead Sea Scrolls have yet to be fully published, but preliminary study has shown that sometimes they contain readings attested only in the Samaritan Pentateuch or presupposed in the Septuagint, the third-century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" Greek translation.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP16",
      "id": "ap_NBP16-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])]), _vm._v(" Rarely are these readings superior to the traditional Massoretic Text, and as Gray has shown even when the ancient versions differ from the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MT")]), _vm._v(", they do not usually presuppose the existence of a different Hebrew reading but are attempts to interpret the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("MT")]), _vm._v("."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP17",
      "id": "ap_NBP17-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Only in the old poems contained in Numbers 21 – 24 is there a noticeable degree of textual corruption. Here the versions offer very little assistance in improving the text, and conjectural emendation and philological reinterpretation are necessary to make sense of the text in a few passages.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("This commentary is based directly on the Hebrew text, but I have generally quoted the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("RSV ")]), _vm._v("translation except where I disagreed with its rendering. Differences between it and the "), _c('span', {
    staticClass: "small"
  }, [_vm._v("NEB ")]), _vm._v("and "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TEV ")]), _vm._v("are noted where these involve emendation of the Hebrew or significant reinterpretation of problematic words.")])]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-008"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("6. Problems of interpreting Numbers")])]), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-001"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("a. The importance of ritual")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("In the preface I alluded to the great gulf that separates the mentality of our age from that of Numbers, a gulf that makes it very hard for us to appreciate much of the book. We are moved by the tragedy of the spies and Moses’ exclusion from the promised land, and we can enjoy the comedy of the Balaam story, but these narratives comprise a relatively small proportion of the whole book. Most of it concerns various rituals and organizational details that are dull to read, hard to understand, and apparently quite irrelevant to the church in the twentieth century. Of course, these problems are not confined to Numbers: the situation is similar in Exodus and Deuteronomy, and even less narrative is to be found in Leviticus.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Yet the sheer bulk of ritual law in the Pentateuch indicates its importance to the biblical writers. This judgment is confirmed by modern anthropologists; for them the key to understanding a society’s fundamental values is its ritual system.")])]), _c('div', {
    staticClass: "cita"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('a', {
    attrs: {
      "id": "page_30"
    }
  }, [_vm._v("Rituals reveal values at their deepest level . . men express in ritual what moves them most, and since the form of expression is conventionalized and obligatory, it is the values of the group that are revealed. I see in the study of rituals the key to an understanding of the essential constitution of human societies.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP18",
      "id": "ap_NBP18-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In short, if we do not understand the ritual system of a people, we do not understand what makes their society tick. It is not without purpose, then, that more than half of the Pentateuch, always "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("considered the most authoritative section of the Old Testament, consists of ritual regulations, instructions about building the tabernacle, laws on sacrifice and festivals and so on. If we can understand these arrangements we shall be near to grasping the very heart of ancient Israel’s religion and its values, at least according to cultural anthropologists.")])]), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But it does not come easily to us. Moderns have a built-in antipathy to ritual and symbolic gestures. We prefer to do without it, and when others use ritual, to ignore it. Victor Turner, who has probably done most in recent times to open up the interpretation of ritual symbolism, candidly admits that when he first studied the Ndembu tribe in Zambia he ignored their rituals. But")])]), _c('div', {
    staticClass: "cita"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_c('a', {
    attrs: {
      "id": "page_31"
    }
  }, [_vm._v("Eventually, I was forced to recognise that if I wanted to know what even a segment of Ndembu culture was really about, I would have to overcome my prejudice against ritual and start to investigate it.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP19",
      "id": "ap_NBP19-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Most Old Testament scholars share a similar aversion to studying ritual. If rituals are really so vital to understanding a society and its values, one would expect books on Old Testament religion and theology to devote long sections to expounding the significance of Old Testament ritual, particularly the sacrificial system. But all the recent works I have consulted slip over this aspect of biblical religion very quickly, though the practice of sacrifice was the very heart of biblical worship.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In this respect modern writers are displaying the same prejudice as the founding father of modern critical study of the Old Testament, Julius Wellhausen. He never disguised which parts of the Bible he liked and which he found uncongenial. Two fundamental value-judgments run through his greatest work, "), _c('i', [_vm._v("Prolegomena to the History of Israel ")]), _vm._v("(1878). The first is that freedom and spontaneity are good, while organization and ritual are bad. The second is that spontaneity is early, but organization is late. These presuppositions of his work explain how he can argue with such conviction for the order of sources JEDP. JE, where worship is free and disorganized, was "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("written first; D, with its organizing tendencies, came next; the hide-bound ritualism of P must be latest of all.")])]), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_32"
    }
  }, [_vm._v("While it is easy to guy Wellhausen’s approach to the history of Israelite religion by saying that he saw the liberal Protestantism of JE gradually degenerating into the mediaeval Catholicism of P, it must be admitted that his basic value-judgments are shared by very many who would not subscribe to his critical position. This no doubt partially explains the continuing attraction of his views, however doubtful some of the intellectual arguments in their favour may be. It has been shown that Wellhausen’s immediate intellectual precursors were de Wette and Herder, the great philosopher of history who wrote in the late eighteenth century.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP20",
      "id": "ap_NBP20-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")])]), _vm._v(" More broadly still one could describe his basic outlook as common to post-enlightenment man."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP21",
      "id": "ap_NBP21-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" Boschwitz aptly summed up Wellhausen’s work by saying it enshrined the essence of Protestant individualism."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP22",
      "id": "ap_NBP22-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This gives a clue as to why we find ritual as such, and the Old Testament law in particular, so dull and uncongenial. Not only do we not realize its significance, but we minimize the importance of form and organization in both our religious and secular callings. The evangelical Christian tends to regard extempore prayer as more spiritual than liturgy. Casual modes of dress and speech, e.g. the widespread use of Christian names, bespeak a society that wants to remove the markers of social stratification which characterized it in the past. Charismatic house groups spring up to replace the long-established churches. Though such attitudes are more obvious among Protestants, similar trends are discernible within Catholicism. Yet ultimately we cannot get away from both ritual and organization. If hand-shaking is on the decline, kissing is on the increase. A university lecturer may no longer wear a gown and mortar-board, but he can still be distinguished from his students by "), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("his tie and sports jacket. Students freed from the shackles of compulsory school uniform almost immediately adopt the unofficial uniform of their peers. House groups claiming to dispense with formal liturgy and professional ministers soon establish their own idiosyncratic way of conducting worship and a recognized leadership, for without organization they wither away. Thus, however much ritual and organization are anathema to modern man, they re-emerge despite the most strenuous attempts to eliminate or minimize them.")])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is no good, then, ignoring rituals as if they were of no consequence. Every society has them, though the outsider is always more aware of them than the native. The latter has grown up with them and takes them for granted, while someone entering a foreign culture is immediately conscious of the differences between his own customs and those of the people he is now living among. He soon realizes that he must assimilate his habits to his neighbours’, if he wishes to be accepted as part of their society. This outward assimilation of behaviour to the accepted norms of the society is taken at least to indicate conformity to local values and attitudes. It is thus essential to attempt to understand a society’s rituals, if we are to understand its values; and if we are to understand its religion, we must pay very close attention to its manner of worship and the rituals associated with it.")])])]), _c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-002"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("b. The essence of ritual")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("What then is the essence of religious ritual in the Bible? It is a means of communication between God and man, a drama on a stage watched by human and divine spectators. Old Testament rituals express religious truths visually as opposed to verbally. They are the ancient equivalent of television; the ancient equivalent of radio was prophecy and prayer. These were the recognized modes of communication between the human and divine worlds in Bible times. Like words, rituals are a two-way channel of communication. On the one hand they are dramatized prayers, expressing men’s deepest hopes and fears; on the other hand they are dramatized divine promises or warnings, declaring God’s attitude to-wards man.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }, [_vm._v("A clear example of the two-sided nature of ritual is found in the ")]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("ordeal prescribed for a woman suspected of adultery (Num. 5:11– 31). Basically this is a curse that if she is guilty, she will be childless. The curse, however, is elaborated in several different ways: the woman offers a sacrifice, her hair is untied, she drinks a potion containing dust from the tabernacle floor, and the very words of the curse. These actions underline the seriousness of the suspected fault. The ritual gives public expression to the national and the divine abhorrence of adultery. It is both a prayer to God for judgment if she is guilty and a warning from him that she will not escape. This double-sided nature of ritual is also evident in the New Testament rites. Baptism declares both the forgiveness of sins by God to the penitent and is also a confession of faith by the believer (Acts 2:38; Rom. 6:1–9).")])]), _c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Though these rituals may be likened to television, the analogy is rather weak. Television may be vivid, but it does not permit spectator participation, which is of the essence of Old Testament rituals. Everyone involved had to play his own role on a public stage under the eyes of man and God. No-one would fancy being put to the public ignominy of the adultery ordeal. Very few would care for the expense, let alone the messiness, of Old Testament sacrifice. It is easy to sing,")]), _vm._v(" "), _c('div', {
    staticClass: "cita"
  }, [_c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Just as I am, without one plea,")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea last"
  }, [_vm._v("But that Thy blood was shed for me;")])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("but to bring a whole bull, kill it, skin it, chop it up and then watch the whole lot burn on the altar, would be quite another matter. Yet this was precisely what someone who offered a burnt offering (Lev. 1) was expected to do. Without doubt these Old Testament rituals were a prodigiously powerful teaching medium; the most eloquent modern preacher is dumb by comparison.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }, [_vm._v("It is important to notice that the use of rituals and symbols was not confined to crisis situations that would precipitate the need for a public ordeal or the offering of sacrifice. The Pentateuch is concerned to create a total religious environment replete with reminders of God’s presence, his promises and his demands. The most striking of these is the tabernacle itself, described in much detail in Exodus 25 – 40. Like the rituals we have already discussed, there are two ")]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("aspects to the symbolism of the tabernacle. It served both as a pledge of God’s presence with his people, and as a warning of his holiness and his demands. Similarly the food laws (Lev. 11; Deut. 14) and prohibitions against mixtures (Lev. 19:19; Deut. 22:9–11) acted as daily reminders that God had separated Israel from the nations to be a people of his own possession, and effectively served to segregate the holy people of God from their Gentile neighbours. Today people wear rings, badges and crosses as marks of status or convictions. The Old Testament also provides for such symbolic ornaments. Everyone had to wear tassels on their clothes as a reminder that they belonged to a kingdom of priests and a holy nation and therefore had to obey the commandments (Num. 15:38–41; Deut. 22:12). Deuteronomy prescribes that extracts from the law had to be bound in little boxes and carried on the forehead or wrist ("), _c('i', [_vm._v("tĕpillîn)")]), _vm._v(" or fastened to the doorposts ("), _c('i', [_vm._v("mĕzuzôt)")]), _vm._v(" as a means of teaching children the importance of the law (Deut. 6:7–9).")])]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-003"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("c. The interpretation of ritual and symbol")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_35"
    }
  }, [_vm._v("Though these rituals and symbols may have been highly effective teaching media in their own day, it is extraordinarily difficult to recover their original meaning today. This is demonstrated by the very different interpretations placed on the various sacrifices, or on the significance of the food laws. Often one feels that the commentators, sure that these ancient texts have a message both for Old Testament times and for today, are guessing wildly in an attempt to make the text relevant. Bonar, for example, held that sheep were clean because they remind the believer that the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _vm._v("is his shepherd, but that pigs were unclean because they are pictures of men wallowing in the mire of iniquity.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP23",
      "id": "ap_NBP23-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Keil, still one of the most valuable nineteenth-century commentators, can be equally arbitrary when interpreting sacrificial ritual. For example, he states that sin offerings were instituted for putting an end to the separation between man and God created by sin. This is symbolized in the sin-offering ritual by the worshipper placing his "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }, [_vm._v("hand on the animal’s head and thereby transferring his sin and his desire for forgiveness to the animal.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP24",
      "id": "ap_NBP24-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Attractive though such an interpretation is, and it may contain an element of truth, it clearly fails as an explanation of the sin offering in particular, for all sacrifice involved the imposition of the worshipper’s hands and the animal’s death. Why does this action point to vicarious suffering in the sin offering but not in other sacrifices where it occurs, for example in the burnt offering, whose atoning significance Keil denies? Furthermore, Keil’s interpretation of the sin offering, while attaching peculiar significance to those features it has in common with all sacrifices, completely fails to explain its distinctive features, namely smearing the blood on the altar, in the holy place or on the mercy seat.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The reason why these rituals are so difficult to understand is that they are so rarely explained in the Bible, or so briefly that several interpretations are possible. Descriptions of the rarer sacrifices, the sin offering ("), _c('i', [_c('span', {
    staticClass: "mev1"
  }, [_vm._v("ḥ")]), _vm._v("a"), _c('span', {
    staticClass: "mev1"
  }, [_vm._v("ṭṭ")]), _vm._v("ā’t)")]), _vm._v(" and guilt offering ("), _c('i', [_vm._v("’āšām")]), _vm._v("), give a number of clear hints as to their significance, but the very different interpretations placed on the sin offering by Milgrom and Keil merely highlight our problem. The more common sacrifices, the burnt offering, cereal offering and the peace offering, receive practically no explanation in the text. They are all said to be "), _c('i', [_vm._v("’’iššêh ")]), _vm._v("(possibly ‘fire or food offerings’) making a ‘pleasing odour to the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’ (Lev. 1 – 3). Such a remark does not take us very far. To say that a sacrifice produces a ‘pleasing odour’ means that God likes them. But why? And what differentiates the burnt offering from the peace offering, apart from the outward ritual acts? Leviticus 1:4 says the burnt offering ‘makes atonement’ for the offerer, but again the interpretation of that word is uncertain, and raises the question whether the burnt offering differs at all in its function from the sin offering.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Faced with the apparent insolubility of arriving at an objective interpretation of the sacrifices, the majority of modern commentators on Numbers have more or less given up attempting to understand them and concentrate instead on discussing the "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("sources and redaction of the book. But that is to bid farewell to the commentator’s central task, interpretation of the present form of the text.")])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Very little is said in the Old Testament itself about the significance of these sacrifices because it was so self-evident to writers that they did not need to explain them. But the modern reader of the Old Testament ritual texts feels he is watching charades; faced with some of the other religious symbols he is as perplexed as by a piece of abstract art. In charades the spectator can always ask the actors whether he has correctly guessed what they are doing. The human authors of the Pentateuch are dead and can no longer be questioned about their meaning, so the modern reader is left wondering whether his guess is right.")])])]), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-004"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("d. An anthropologically based approach to ritual symbolism")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_37"
    }
  }, [_vm._v("Into this apparently hopeless situation light has begun to shine from an unexpected quarter. Social anthropologists in seeking to understand primitive societies have developed an approach to the interpretation of ritual which can be applied with some modification to the biblical texts. Three seminal works")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP25",
      "id": "ap_NBP25-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" by anthropologists have pointed a way forward to determining with greater objectivity the significance of ritual and associated symbols. Of course, there are problems in applying anthropological methods to ancient texts. Their methods have been devised to interpret living societies where informants are available to test the investigator’s hypotheses. Furthermore the data contained in the Old Testament are much less than a total description of Israelite society, which would be necessary to prove our interpretations beyond cavil. Yet just as the methods of modern linguistics have been successfully applied to the study of dead languages,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP26",
      "id": "ap_NBP26-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" there is no reason in principle why "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("anthropological methods devised to study living cultures should not be applied with profit to extinct societies.")])]), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("This is not the place to attempt to justify in detail the application of anthropological methods to the study of the Old Testament. The ultimate test must be the fruitfulness of the methods themselves. My main concern is to explain how I have sought very tentatively to apply these methods myself in the body of the commentary. Nevertheless it is worth setting out some of the reasons for supposing this general approach to be valid, even if some of the details remain open to question.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("First, this approach seeks to understand the whole ritual system and not just parts of it, or more precisely to understand the parts in the light of the whole. This may be illustrated by Douglas’ approach to the food laws. Earlier commentators picked on certain elements in the food laws as suggestive of a particular interpretation. For instance, sheep were clean because they reminded man of his divine shepherd, while serpents were unclean because they recalled the agent of the fall. But multitudes of animals in the list found no easy explanation of this type, for example, camels, eagles, grasshoppers, etc. Douglas drew attention to that feature of the lists in Leviticus 11 and Deuteronomy 14 that the biblical writers seem to concentrate on, namely the means of locomotion of the animals, how many feet and what type of feet they have. From surveying the lists as a whole she deduced that the animal world mirrors the human world. Just as there are three principal divisions among men, Gentiles, Jews and priests, so there are three classes of animals: unclean, that may not be eaten; clean, i.e. edible; and sacrificial beasts. Her theory of a correspondence between the human and the animal kingdoms is confirmed by other texts scattered throughout the Pentateuch.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_38"
    }
  }, [_vm._v("Secondly, Soler has independently arrived at a similar analysis of the food laws to that of Douglas. Indeed his study represents an advance on her work, showing that the correspondences between animals and men run even deeper than earlier realized. The birds listed as unclean are unclean because they are birds of prey, i.e. eat flesh with blood in it, a mortal sin under Old Testament law (Lev. 17:10– 14). It is the herbivorous land animals that are clean, and according to Genesis 9:3 (cf. 1:29f.) man too was vegetarian until after the flood. ")]), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }, [_vm._v("It is also worth noting that Carmichael,")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP27",
      "id": "ap_NBP27-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")])]), _vm._v(" using more traditional methods of exegesis, has arrived at similar conclusions. He argues that in Genesis 49 and Deuteronomy 22:10 the ox, the best of the sacrificial and clean animals, symbolizes Israel, while the ass, an unclean beast, pictures Canaan. This convergence of interpretation, based on several different methods of study, suggests that the symbolic dimensions of biblical thought are at last being understood.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Thirdly, this interpretation is corroborated in the earliest commentaries on these laws. For example, the second-century "), _c('span', {
    staticClass: "small"
  }, [_vm._v("BC")]), _vm._v(" Letter of Aristeas sees the behaviour of clean animals as models for human conduct."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP28",
      "id": "ap_NBP28-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Acts 10 links the preaching of Peter to the Gentiles with eating unclean animals. In other words, as soon as men of all nations could belong to the people of God, those food laws which had symbolized Israel’s election and served to separate her from the nations became irrelevant too.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The anthropologists’ interpretation of Old Testament sacrifice as substitutionary seems to be endorsed by the New Testament too. The New Testament writers employ the categories of Old Testament sacrifice to explain the death of Christ. He is the lamb of God who died in our place. Yet Old Testament scholars tend to deny or play down the substitutionary aspect of sacrifice."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP29",
      "id": "ap_NBP29-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" By placing his hand on the animal’s head, the worshipper is only saying he owns the animal. ‘This animal belongs to me, therefore I should benefit by the sacrifice.’ But the anthropologist Edmund Leach confidently asserts, ‘The plain implication is that, in some metaphysical sense, the victim is a vicarious substitution for the donor himself.’"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP30",
      "id": "ap_NBP30-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" t may be added that in some Hittite rituals the animal is explicitly described as a substitute for the worshipper."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP31",
      "id": "ap_NBP31-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("Now this recognition of the substitutionary concept of sacrifice fits in very well with Douglas’s and Soler’s observations on the tie-up between the animal world and the human situation. The Israelite, a member of the clean nation, chooses a clean animal to sacrifice on his behalf. The imposition of hands makes the equation even more explicit. But a sacrifice is not merely a suitable animal being offered for the group of people symbolically identified with it. The individual Israelite must choose it himself and then place his hands on its head in a dramatic declaration that he is this animal, that it is taking his place in the ritual.")])]), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Invaluable as these studies are, however, they can only provide a general pre-understanding of ritual symbolism. The next stage in the process of interpretation has been expounded by Edmund Leach in "), _c('i', [_vm._v("Culture and Communication ")]), _vm._v("(1976). Basically one must examine the whole ritual and symbolic system of ancient Israel and note the distinctions and gradations within it. It is the contrasts between similar elements within the system that are of primary importance, not the individual elements in it. Thus in the tabernacle different colours and materials are used in different parts: for example, the curtains round the outer courtyard were white, whereas those in the holy of holies were blue; the clasps for the courtyard curtains were silver, but those in the holy of holies were gold; the courtyard altar was covered in bronze, but that in the holy place was made of gold. This series of differentials points to the holy of holies being the most sacred spot, where God himself dwelt.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_40"
    }
  }, [_vm._v("In interpreting rituals Leach insists similar procedures must be followed. (I find his own examples drawn from Leviticus rather too superficial to be convincing: Milgrom’s work")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP32",
      "id": "ap_NBP32-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" illustrates Leach’s principles much better, though he docs not in fact appeal to anthropological method to justify it.) To discover the meaning of a sacrifice, all the occasions on which it is offered must be examined: similar situations will demand a similar sacrificial response. Thus, if the reason for making an offering on a particular occasion can be discovered, one may assume that it was for similar reasons that the offering was required on other occasions. Rarely in fact are sacrifices "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("offered alone, and this complicates the situation. Then one must discover which combination of sacrifices is offered on what occasion. For example, the Nazirite on completing his vow must offer burnt, sin, peace, cereal and drink offerings all together (Num. 6:14f.). These sacrifices were also required on the first and eighth day of the priest’s ordination (Lev. 8 – 9). This is one of several hints in the Nazirite law that the sanctity of the Nazirite was on a par with that of the priests.")])]), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_41"
    }
  }, [_vm._v("The third stage of interpreting ritual has been pioneered by Victor Turner, though unlike the previous writers he has not applied his methods directly to biblical texts. He insists that to find the full meaning of a rite, one must not only examine its function within the total system, but also take account of all the elements within the rite.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP33",
      "id": "ap_NBP33-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" On this basis it is not merely the sequence of colours and metals within the tabernacle that is significant; the particular materials themselves have symbolic significance. I would suggest, therefore, that the holy of holies was decorated with gold, purple and blue furnishings because these were the marks of royalty and divinity, and because this part of the tabernacle was the throne-room of Israel’s divine king.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("But how are we to arrive at such conclusions? Modern anthropologists can ask the natives; our would-be informants are long since dead. This poses our greatest danger. Once admit that every element possesses symbolic significance, and we may be tempted to invent meanings indiscriminately, returning full circle to the unscientific exegesis of some older commentaries. We must have controls if symbolic interpretation is not to suffer from the whims of imaginative commentators. The following principles, I suggest, may preserve us from going too far astray in interpreting individual features within a rite.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("First of all, the meaning of an element should be suggested elsewhere in Scripture. Poetic metaphor may often provide a clue to the meaning of symbols, as for example, when Israel is identified with the ox, or blood with wine. Unfortunately this principle does not suffice to explain every feature in Old Testament rites and then we must "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }, [_vm._v("look further afield for possible meanings. Some colours, e.g. black, white and red, have almost universal significance.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP34",
      "id": "ap_NBP34-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")])]), _vm._v(" Cultures from very different places tend to view white positively, e.g. as symbolizing life and purity. Comparative studies particularly of ancient near eastern sources may suggest interpretations of features of Israelite ritual symbolism."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP35",
      "id": "ap_NBP35-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])]), _vm._v(" It must be borne in mind, however, that a particular animal or colour or gesture in one culture may have quite a different symbolic value in another culture. A word in one language may sound very similar to that in another language, and the meanings be quite different. The problem here is like that posed by those comparative philologists who suggest new meanings for Hebrew words on the basis of cognate languages. The same criteria should apply to evaluating the meaning of symbolic elements in ritual: a meaning suggested by a culture close in space and time to ancient Israel is more likely to be valid than one derived from a more distant culture."), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP36",
      "id": "ap_NBP36-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Secondly, though other passages of Scripture and neighbouring cultures may suggest meanings for elements of rites, ultimately this interpretation must be compatible with the overall purpose and function of the rite as recovered by the systematic analysis of that rite and similar ones. Just as in a sentence the context determines which of several possible meanings fits a particular word, so the ultimate test of any proposed interpretation of a symbolic element is the overall purpose and function of the ritual. For example, Numbers 19 prescribes a mixture of water and ash to purify people who have had contact with the dead, and it therefore must be presumed that all the ingredients burnt to make this ash had something to do with purification. In other words the basic meaning of a rite as deduced by the methods of Leach and Milgrom outlined earlier must control the interpretation of individual elements within it. In some instances, a variety of symbolic interpretations seems to fit the "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }, [_vm._v("context, e.g. the dust added to the water in Numbers 5:17. In this instance we need not necessarily choose between the various meanings, for by their very nature symbols are multivocal,")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP37",
      "id": "ap_NBP37-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")])]), _vm._v(" bearing a variety of connotations simultaneously.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("A few more detailed examples may clarify the method being advocated. Numbers 15 insists that the burnt offering and peace offerings should always be accompanied by a cereal offering and a libation of wine. However, it never explains why or what these accompanying rites signified. How should the cereal offering and the drink offering be interpreted?")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The following approach is one possibility. Elsewhere in the sin offering (Lev. 5:11–13) a cereal offering may replace the offering of animals. Thus, if in the sin offering the animal represents the worshipper, it follows that grain when substituted for the animal also represents the worshipper. This hypothesis is confirmed I believe by the following observation: in animal sacrifice the animal chosen is always a clean animal, i.e. one that symbolizes Israel, or more exactly the Israelite priests. Wheat, the usual ingredient of the cereal offering, also represents Israel, for the twelve wheaten loaves of shew-bread (Lev. 24) clearly symbolize the twelve tribes of Israel. Therefore in the cereal offering, the presentation of the grain to the priest and the burning of part of it on the altar represent the immolation of the worshipper himself. It echoes very clearly the meaning of the animal sacrifice it accompanies. Indeed burnt offerings, peace offerings and cereal offerings are all alike called "), _c('i', [_vm._v("’’’iššêh")]), _vm._v(", ‘food or fire offerings’.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Similarly the ritual of pouring out wine at the foot of the altar as a libation appears to equate wine, which is often red, with blood; and wine is a regular scriptural metaphor for blood (Gen. 49:11; Rev. 14:20). Furthermore one of the favourite descriptions of Israel is the vine (Ps. 80:8, 14; Isa. 5:1–7; Hos. 10:1); thus the material chosen for the libation, like the animals chosen for sacrifice, immediately suggests an identification between the offerer and his offering. The wine libation like the outpouring of animal blood portrays the worshipper dying for his sin and giving himself totally to the service of God.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_44"
    }
  }, [_vm._v("It may then be objected that the burnt offering and its traditional accompaniments, the cereal offering and the drink offering, each symbolized much the same thing, thereby rendering the latter two redundant. However, this is characteristic of symbolism")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP38",
      "id": "ap_NBP38-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" and indeed of much great art. Saying the same thing in a variety of ways reinforces and enhances communication. Remarks made only once are generally unimportant and soon forgotten. Elegant repetition and variation characterize great music, drama, literature and liturgy. The message of the burnt-offering ritual, dramatically setting out the effect of sin and the need for total consecration to God’s service, is powerful enough on its own. Intensified by the accompanying rites of cereal offering and libation, it becomes overwhelming.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("It is on these lines that I have tried to understand the symbols and rituals of Numbers in the following commentary. Yet the reader is warned that the suggested interpretations are very tentative. Though totally persuaded of the importance of ritual and symbolism, I am far from certain that I have discovered the correct interpretation of the rites in Numbers. If these suggestions stimulate others to pursue the issues further, biblical interpretation could take a significant step forward in a field of great importance, hitherto sadly neglected.")])])]), _vm._v(" "), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-009"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("7. The theology of Numbers")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("It is impossible to discuss the theology of Numbers in isolation from the other books of the Pentateuch, particularly Exodus and Leviticus. The outward structural devices that link the three middle books of the Pentateuch point to an inner unity of theological theme that underlies them all. All are concerned with the outworking of the promises to Abraham and the moulding of Israel into the holy people of God. But the focus of interest in each book is different. Exodus concentrates on the deliverance from Egypt, the covenant at Sinai and the erection of the tabernacle. Leviticus highlights the nature of true worship and holiness. Numbers focuses on the land of promise and Israel’s journey towards it. God’s character "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("and his reactions to Israel’s behaviour are constant throughout these books, but different aspects come to the fore in different books. If Leviticus emphasizes the importance of holiness and cleanness, Numbers reiterates the value of faith and obedience. Where Leviticus stresses the role of sacrifice in creating and maintaining right relations between God and man, Numbers accentuates the indispensability of the priesthood for preserving the nation’s spiritual health. Yet these contrasts are not incompatible with one another. It is through obedience to the law that Israel is sanctified, and without priests there can be no sacrifice. The theological emphases of the different books do not contradict but complement one another. Therefore, in the exposition that follows, while I have picked out topics that are most prominent in Numbers, I have not refrained from utilizing passages from other parts of the Pentateuch bearing on these topics.")])]), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-005"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("a. The character of God")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_vm._v("Numbers, like other parts of Scripture, does not attempt to paint a detailed portrait of God’s character. Nevertheless in its laws and narrative certain traits emerge very clearly.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_45"
    }
  }, [_vm._v("Fundamental to Israel’s experience was "), _c('i', [_vm._v("the real and visible presence of God among them. ")]), _vm._v("In one sense God was ever present with Israel; the recurrent refrain in the laws of Leviticus, ‘I am the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _vm._v("your God’, is a reminder that every deed is done unto the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(". But Numbers speaks of God’s frequent visible presence with his people during their wilderness wanderings. The fiery cloud covering the tabernacle showed that it was no empty royal palace, but that ‘the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _vm._v("their God is with them, and the shout of a king is among them’ (23:21). Wherever the cloud went the people followed; when the cloud stopped moving on, the people camped (9:15–23). So impressive was this phenomenon that not only did the Mesopotamian seer Balaam recognize it, but so did the Egyptians and Canaanites according to 14:14: ‘They have heard that thou, O L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", art in the midst of this people; for thou, O L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", art seen face to face, and thy cloud stands over them and thou goest before them, in a pillar of cloud by day and in a pillar of fire by night.’ Ultimately it would lead them to the land of promise which would be hallowed by the presence of God living among his people (35:34). The moving cloud and the ark were images of God going with his people to ")]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("protect them and give them victory over their foes (10:33–36). In their absence defeat was inevitable (14:43–44). More ominous still, the cloud appeared in moments of crisis, when the people protested against the divinely appointed leadership or the planned journey into Canaan. The cloud’s sudden appearance heralded some dire punishment on the wicked (11:25, cf. 33; 12:5, 10; 14:10; 16:19, 42; 20:6).")])]), _c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("These judgments demonstrated "), _c('i', [_vm._v("the holiness of God")]), _vm._v(", another aspect of his nature underlined throughout the Pentateuch. Just as Mount Sinai was fenced off and any trespasser stoned or shot (Exod. 19:12–13), so the tabernacle had to be separated off from the tribes encamped around it by a cordon of priests and Levites empowered to execute any unauthorized person drawing near (1:49 – 3:10). Even those Levites, the sons of Kohath, appointed to carry the sacred furniture of the tabernacle, such as the ark and golden candlestick, were not permitted to see these very holy objects uncovered. They had to be wrapped up first by the priests lest laymen saw them and died (4:1–20). In other words these most potent symbols of the presence and power of God partook of his holiness. Just as no man may see God’s face and live (Exod. 33:20), so none but the priests could see these symbols of his presence without experiencing sudden death. Even the most privileged, those who had immediate and ready access to God such as the priests, could not with impunity flout the demands of divine holiness. Aaron’s sons died for offering incense ‘such as he had not commanded’ (Lev. 10:1). Numbers 20:12 records that Moses and Aaron were sentenced never to enter the promised land for deviating slightly from God’s instructions. The comment of Leviticus 10:3 on the former incident applies equally to the second: ‘I will show myself holy among those who are near me, and before all the people I will be glorified.’")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_46"
    }
  }, [_vm._v("But God’s holiness is tempered by "), _c('i', [_vm._v("his graciousness")]), _vm._v(", a third attribute of his character on which Numbers lays great stress. The appointment of the priests and Levites to minister in the tabernacle is an act of mercy designed to prevent his wrath engulfing the nation (3–4, 16–18). Several times it is recorded that God’s judgments are halted by Moses’ intercession (11:2; 12:13; 14:13–20; 21:7) or by priestly acts of atonement (16:47; 25:7). Even Israel’s experiences in the wilderness are proof of God’s goodwill towards them; for the generation that came out of Egypt experienced the fulfilment of all the ")]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("promises made to the patriarchs save that of entering the land of Canaan, for which they had only their unbelief to blame. It is to these promises that Moses appeals when God threatens to annihilate Israel for their unbelief (14:16; cf. Exod. 32:13). Balaam’s oracles also allude to many features in these promises. Because God has blessed them, Balaam cannot curse them (23:8; 24:9; cf. Gen. 12:2–3). Israel is as numerous as the dust of the earth (23:10; cf. Gen. 13:16). They will settle and prosper in the land (24:6ff.; cf. Gen. 13:17). Kings shall arise from them (24:7, 17; cf. Gen. 17:16). Again, the census lists (chs. 1, 26), especially the second, emphasize the growth of Jacob’s family, and serve as implicit reminders of the fulfilment of the promises, even though there is no explicit reference back to them. Similarly, the description of the cloud guiding the tribes through the wilderness (9:15–23) bears comparison with Genesis 28:15: ‘Behold, I am with you and will keep you wherever you go, and will bring you back to this land.’")])]), _c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("God’s graciousness is revealed not only in his present actions and his past promises, but also in his laws for the future. This comes out most vividly in chapter 15. The whole project of entry to Canaan has suffered a catastrophic set-back as a result of the spies’ report. The adults have been condemned to die in the wilderness. A sudden burst of penitence has prompted an attempt to enter the land, but it has ended in ignominious defeat. The next chapter, a set of laws about sacrifice, begins ‘When you come into the land you are to inhabit, which I give you’ (15:2). There follow detailed instructions about the amounts of wine, oil and flour, that must accompany animal sacrifices, materials available, at least in the quantities specified, only in a settled farming community. These laws, then, underline the promise of entry to the land. They assure the people that, notwithstanding their recent unbelief, their children will enjoy the fulfilment of the promises. Similarly, the laws at the end of the book about the land are a further assurance that it will soon be theirs. God will put the people in a position where they can obey these laws (33:50 – 36:13).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_47"
    }
  }, [_vm._v("One final aspect of God’s character stressed in Numbers is "), _c('i', [_vm._v("his constancy. ")]), _vm._v("Once again Balaam spells out what the whole story implies: ‘God is not man . . that he should repent’ (23:19). The two short travelogues in chapters 11 – 12, 20 – 21 record incidents similar to ")]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("the earlier journey described in Exodus 13 – 18. Similarly, the revelations associated with Kadesh (13 – 19) and with the plains of Moab (22 – 36) recall, modify and expand the earlier legislation revealed at Sinai (Exod. 19 – Num. 10). This threefold repetition spanning forty years suggests that every generation must appropriate the law for themselves and experience both the grace and judgment of God. The briefer, less detailed itinerary of chapter 33, with its pattern of six cycles of seven stations, re-emphasizes that God is ever constant in working out his purposes, even when to the human observer nothing significant seems to be happening.")])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("All these aspects of God’s character are endorsed in the New Testament. In our Lord Jesus ‘the Word became flesh and tabernacled among us’ (John 1:14). Through the spirit the believer has become the temple of God (1 Cor. 3:16–17; 6:19). The heavenly Jerusalem is described as a place where the ideals of Numbers find their ultimate fulfilment: ‘I heard a loud voice from the throne saying, “Behold, the dwelling of God is with men. He will dwell with them, and they shall be his people” ’ (Rev. 21:3).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Similarly the New Testament re-affirms the doctrines of the holiness, graciousness and constancy of God. ‘He who called you is holy’ (1 Pet. 1:15), and Paul sees the stories of judgment in Numbers as warnings for the Corinthians (1 Cor. 10:1–11; cf. Heb. 12:18–29). The grace of God is the principal theme of the New Testament: ‘All the promises of God find their Yes in him’ (2 Cor. 1:20). Finally, regarding his constancy: ‘he remains faithful – for he cannot deny himself ’ (2 Tim. 2:13). ‘Jesus Christ is the same yesterday and today and for ever’ (Heb. 13:8).")])])]), _c('a', {
    attrs: {
      "id": "page_48"
    }
  }), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-006"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("b. The land")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_48"
    }
  }, [_vm._v("The whole book of Numbers looks forward to the occupation of the land of Canaan. Chapters 1 – 10 describe the preparations for the journey from Sinai to Canaan, 11 – 12 the journey itself, 13 – 14 the abortive attempt at conquest. The rest of the book describes the subsequent period of wanderings and their period of waiting in Transjordan prior to their entry. Canaan is the ever-present goal of the people, that is never quite reached in Numbers. The geographic limits of Canaan (34:2–12) from the Mediterranean in the west to the river Jordan, and from Mount Hor in the north to Kadesh-barnea ")]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("in the south, correspond to the Egyptian administrative district with the same name known from fifteenth-century texts onwards.")])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Theologically three aspects of this land are emphasized in Numbers. First, "), _c('i', [_vm._v("the LORD had given it to Israel ")]), _vm._v("(32:7, 9). More precisely, he had sworn to give it to Abraham, Isaac, and to Jacob (32:11; cf. 14:16; Gen. 17:8; 26:3; 28:13). These promises guaranteed that Israel would be able to conquer the land at the right time; the spies’ unbelief was all the more heinous because their mission had specially visited the Hebron area where Abraham had first been promised the land, and where he and his family were buried (13:22–24; cf. Gen. 13:14 – 18:1; 23; 35:27–29; 50:13).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Second, "), _c('i', [_vm._v("the land of Canaan was to be a holy land")]), _vm._v(", sanctified by God dwelling among his people (35:34; cf. Lev. 26:11–12). For this reason the native inhabitants were to be driven out, and their sanctuaries and idols destroyed. The L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _vm._v("alone was to be worshipped there (33:51–52). God’s presence would ensure that it would indeed be a land ‘flowing with milk and honey’ (13:27; 14:8) where the people would continue to multiply and enjoy life (24:5–7; Lev. 26:3–10). But death, particularly violent death, would pollute the land. Only the execution of the murderer, or in the case of manslaughter the death of the high priest, could rid the land of blood guilt (35:31–34; cf. Deut. 21:1–9, 22–23).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Third, "), _c('i', [_vm._v("the land was to be Israel’s permanent possession. ")]), _vm._v("This is stated more explicitly in Genesis than in Numbers (e.g. Gen. 13:15; 17:8), but this is the clear implication of the jubilee laws (Lev. 25) and the rules about the marriage of land-owning girls in Numbers 36: ‘each of the tribes of the people of Israel shall cleave to its own inheritance’ (36:9). Disobedience may mean exile from the land, but there is a pledge of ultimate restoration (Lev. 26:40–45; cf. Deut. 30:1–10).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Though the New Testament re-affirms the validity of the patriarchal promises, it sees their scope as universalized (Rom. 9:4). As membership of the people of God now includes all those who are sons of Abraham by faith, so Canaan has become an image of ‘a better country, that is, a heavenly one’, a new Jerusalem from which sin and death are excluded (Gal. 3:7; Heb. 11:16; Rev. 21).")])])]), _c('a', {
    attrs: {
      "id": "page_49"
    }
  }), _c('div', {
    staticClass: "niv2",
    attrs: {
      "id": "niv2-007"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_c('h3', {
    staticClass: "int_niv2"
  }, [_vm._v("c. The people of God")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_49"
    }
  }, [_vm._v("Nowhere is the general biblical principle that the people of God ")]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("should imitate God so well illustrated as in the book of Numbers. Individually and corporately Israel is to express the character of their redeemer. Their unity, holiness and faithful fulfilment of their promises must reflect the unity, holiness and faithfulness of their Lord and Saviour. As the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _vm._v("is one, so Israel must be one nation (Num. 32). ‘You shall therefore be holy, for I am holy’ (Lev. 11:45). As the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _vm._v("keeps his promises, so those who make vows are expected to fulfil them (Num. 30). What is true of the nation as a whole is particularly true of its spiritual leaders. The priests represent Israel before God, and God before Israel, and therefore their behaviour must be altogether godlike. Moses and the high priest in yet fuller measure are expected to incarnate God’s words and attitudes. These parallels between God, Israel, the high priest and Moses make it quite natural for the New Testament to see in them types of Christ, the living Word.")])]), _c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The importance of Israel’s unity is brought out in various ways. The census lists (1, 26) tracing the descent of every member of the nation back to one of Jacob’s sons is a reminder that they were in fact one people joined together by ties of blood. But this unity had to express itself in action: the censuses were held in order to list all those able to go forth to war (1:3; 26:2). Every tribe had to supply a spy indicating its willingness to join in the battle for Canaan (13:2). Each tribe had to supply a thousand men in the war against Midian (31:4). When later the two and a half tribes declared they would be content to settle in Transjordan, this was hailed as a most serious crisis. It suggested not only an indifference to settling in the land of promise, but also unconcern about preserving the unity of the nation. Only when the tribes of Reuben, Gad and Manasseh agreed to send their warriors across the Jordan to fight for Canaan were they permitted to settle in Gilead (32:1–33). When the tabernacle was dedicated, each tribe indicated its full support of the sanctuary and its ministry by presenting a silver plate and basin and a golden spoon and a selection of sacrificial animals. Each offered exactly the same, demonstrating that all equally backed the sacred institutions (ch. 7).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_50"
    }
  }, [_vm._v("Holiness is intrinsic to God’s character, but not to men. Israel was holy in virtue of God’s presence with them and their holiness therefore rested ultimately on God’s initiative rather than human effort. In the covenant ratification ceremonies described in Exodus ")]), _c('a', {
    attrs: {
      "id": "page_51"
    }
  }, [_vm._v("24:3–8 their holy calling was given symbolic expression by their sprinkling with blood and a promise to keep the commandments.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP39",
      "id": "ap_NBP39-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" Though it was not possible for the nation to make itself holy through its own unaided efforts, it was perfectly possible for them to destroy their God-given sanctity. Numbers recognizes two main ways in which this may happen: through disobedience and through uncleanness. As a constant reminder of his duty to obey the commandments, every Israelite had to attach to his clothes a tassel with a blue thread in it, symbolizing his membership of the ‘kingdom of priests and a holy nation’ (Exod. 19:6). ‘So you shall remember and do all my commandments, and be holy to your God’ (Num. 15:40). It was because sabbath-breaking and idolatry were flagrant violations of fundamental covenant demands and incompatible with the holiness of the nation, that those who sinned in this way were punished with the utmost severity (15:32–36; 25:1–9). But unbelief was equally culpable. The spies who refused to believe God would give them the land died in a plague, while those who accepted their report were forced to wander in the wilderness until they had perished outside the land of promise (14:34–37).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Though sin and disobedience come more easily to men than holiness, Scripture refuses to countenance the idea that holiness is somehow unnatural. It is in fact the essence of normality. That is why uncleanness, which may be roughly equated with abnormality, is incompatible with holiness. Uncleanness is caused by skin diseases, ‘leprosy’, which make men look abnormal (5:2; 12:10–14; Lev. 13 – 14), bodily discharges (5:2; cf. Lev. 12; 15), especially illicit sexual intercourse (5:19) and death, the very antithesis of life, the goal of creation (5:2; 31:19; 35:33). All these things are regarded as deviations from the perfection that should characterize all creation, and are therefore incompatible with holiness.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The law prescribes two different remedies for uncleanness: isolation or purification. If a holy man such as a Nazirite or high priest came in contact with a dead body his holiness would be destroyed; elaborate sacrifices are therefore prescribed to restore the sanctity of a Nazirite (6:9–12). The high priest is simply banned from any "), _c('a', {
    attrs: {
      "id": "page_52"
    }
  }, [_vm._v("contact with the dead (Lev. 21:11). But even the lesser sanctity of the nation is jeopardized by uncleanness. Again, those affected must be isolated from the nation until their purity is restored. Numbers 5:2 lays down ‘that they put out of the camp every “leper”, and every one having a discharge, and every one that is unclean through contact with the dead’. When a skin disease cleared up, the sufferer became clean again, but he had to undergo the seven-day procedure of cleansing and re-sanctification described in Leviticus 14:2–32 (cf. Num. 12:9–15). Different cleansing rituals are prescribed for those polluted by discharges or dead bodies (Lev. 12; 15; Num. 19; 31:19–24), but essential in all these procedures was the offering of sacrifice: the ashes of the red heifer were effectively an instant ever-ready sacrifice.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP40",
      "id": "ap_NBP40-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Though every Israelite was holy because he belonged to the holy people, there were different degrees of holiness within the nation. The denial of these distinctions was at the root of Korah’s rebellion. He argued that because all Israel was holy, the priests had no right to claim a special status. He said to Moses and Aaron: ‘You have gone too far! For all the congregation are holy, every one of them, and the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _vm._v("is among them; why then do you exalt yourselves above the assembly of the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("?’ (16:3). The subsequent story disproves Korah’s assertion. The priests are more holy than laymen and therefore enjoy certain privileges denied to laymen. Numbers distinguishes at least four grades of permanent holiness: lay, Levitical, priestly and high priestly; one grade of temporary holiness was acquired through taking a Nazirite vow.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The Nazirite vow (6:1–21) could be undertaken by any lay man or woman pledging to abstain from drinking wine or coming near dead bodies for a time. As a symbol of his consecration the Nazirite did not cut his hair during the period he was under the vow. Abstinence from alcohol and separation from the dead were also required of priests (Lev. 10:9; 21:1), but the Nazirite enjoyed none of the privileges of the priests such as offering sacrifice and receiving offerings. Nevertheless he was still holy unto the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v(", his uncut locks reminding himself and others that total dedication to God’s service was the calling of all Israel. The Levites were the descendants of Levi, one of Jacob’s sons. "), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("Originally they had been a secular tribe without sacred responsibilities; but they had demonstrated such devotion to God when the golden calf was made (Exod. 32:26–29), that they were appointed permanent wardens of the tabernacle. The Israelite tribes camped in a square around the tabernacle with a cordon of Levites separating the tabernacle from the lay tribes (Num. 2 – 3). Their relative closeness to the sanctuary symbolized the greater sanctity of the Levites. Though thus separated from the other tribes, they were at the same time their representatives before God. In the last plague before the Exodus the first-born of the Egyptians died, but the first-born Israelites were spared. Thereafter all first-born boys had to be given to God, and they were therefore expected to serve God in a full-time capacity. However, in Numbers this rather impractical arrangement is replaced by appointing the Levites to undertake the duties of the first-born males (Num. 3). Thus every family in Israel had a stake in the ministry: they could look at the Levites and remember that one of them was serving God instead of the eldest boy in the family. In recognition that the Levites were performing a vital but dangerous ministry on behalf of the whole people, Israel was called to support them by giving them a tithe of all their produce (18:21–24) and by assigning them 48 cities (35:1–8).")])]), _c('a', {
    attrs: {
      "id": "page_53"
    }
  }), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_53"
    }
  }, [_vm._v("Running through all the legislation in Numbers are warnings about the danger of unholy men approaching God. The Levites were appointed to guard the tabernacle from incursions by laymen. Yet even they were not allowed to look at the sacred furniture of the tabernacle or offer sacrifice. Only the priests could perform these holy and dangerous tasks. The Levite Korah supported by men from other tribes contested the special prerogatives of the priestly family. Chapters 16 – 17 relate three signal demonstrations of God’s choice of Aaron’s family. First, Korah and his supporters offered incense, a priestly task; as a result, some were burned with fire, others were swallowed up by an earth slip. Then a plague broke out, a second sign of God’s anger, which was stopped by Aaron offering incense. Whereas incense offered by the official priesthood effects atonement, freelance offerings provoke judgment. The same point is made in the third episode. Sticks representing all the tribes were placed overnight near the ark. In the morning Aaron’s rod had sprouted, all the others were dead. The implication was obvious: if ")]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("anyone but Aaron’s family drew too close to God, he would die. Yet the offering of sacrifice was indispensable if Israel was to remain the holy covenant nation. To sustain their life-giving ministry the priests were therefore awarded a tenth of the tithes, firstlings, first fruits and parts of many of the sacrifices (18).")])]), _c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The priests who drew near to God had to be exemplary in their holiness. They therefore had to avoid pollution that would mar their holiness (Lev. 21:1); indeed, if they suffered from skin disease or discharges, they could not partake of sacrificial food (Lev. 22:2–8). They had to set forth the will of God in their teaching (Lev. 10:11), in their personal relationships (Lev. 21:7), and in their public actions (Num. 25:11). Slight infractions of the commandments by priests were dramatically punished (Lev. 10:1–3), for it was only through the priests’ punctilious performance of their duties that atonement could be made for the nation (Num. 16:46; 25:13).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("At the pinnacle of the system stood the high priest. He was hedged about with yet tighter restrictions than the ordinary priests (Lev. 21:10–14). His supreme holiness was symbolized by his high-priestly vestments, adorned with twelve jewels, one for each of the tribes. He wore these clothes when he entered the outer part of the tent of meeting ‘to bring the names of the sons of Israel to continual remembrance before the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD")]), _vm._v("’ (Exod. 28:29). But even he was permitted to enter the holy of holies, the very presence of God, only once a year (Lev. 16:3). It was a journey fraught with the danger of sudden death, yet indispensable, for ‘thus he shall make atonement for the holy place, because of the uncleannesses of the people of Israel’ (Lev. 16:16). These day of atonement ceremonies enabled God to continue dwelling among his people despite their sinfulness. The atoning work of the high priest culminated in his death. This purged the land of the blood guilt associated with violent death and allowed those convicted of manslaughter to leave the cities of refuge and return home (Num. 35:28, 32).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_54"
    }
  }, [_vm._v("Finally, there is the figure of Moses. His office was unique. Whereas Aaron’s son succeeded him and enjoyed a similar authority to his father, Joshua was invested with only a part of Moses’ authority. Whereas Moses instructed Aaron what to do, Eleazar was to guide Joshua using the Urim and Thummin (Num. 20:24–28; 27:15–22). In his person Moses combined the roles of prophet, priest and ")]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("king. He demonstrated his prophetic calling in declaring Israel’s future, setting out God’s will in the law and interceding for the people (cf. Deut. 18:18). Moses showed himself first of the priests at the ordination of Aaron, when he played the role of priest while Aaron acted the layman (Lev. 8). And as judge, military commander and shepherd of his people Moses fulfilled all the duties later generations expected of their kings (cf. Num. 15:32–36; 27; 31; 36).")])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The New Testament views Israel (Matt. 2:15), the high priest (Heb. 3 – 10) and Moses (Matt. 17:3; Luke 16:29, 31; John 5:46; Acts 3:22; Heb. 3:2ff.) as types of Christ, that is, their life and work anticipate his ministry in various ways. It also sees Israel as a type of the church. Like Israel the church is one body, and must express that unity in united action (Eph. 4:3–16; 1 Cor. 1:10–17). Like the ancient Israelites, all Christians are saints: ‘You are a chosen race, a holy nation, God’s own people’ (1 Pet. 1:2 – 2:9; cf. Exod. 19:5–6). Yet they must work to make this holiness a practical reality (1 Pet. 1:15–16).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("The death of Christ has made obsolete the sacrifices which the priests of the old covenant used to offer (Heb. 10), but their New Testament counterparts, the bishops and elders, still have to teach the word of God and set forth the character of God in the holiness of their lives (1 Tim. 3; Titus 1:5–9). Like the priests and Levites, the ministers of the gospel are entitled to ample material rewards in recognition of the great spiritual benefits they bring to the people of God (1 Cor. 9:13–14; 1 Tim. 5:17–18).")])])]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_55"
    }
  }), _c('div', {
    staticClass: "niv1",
    attrs: {
      "id": "niv1-010"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_c('h2', {
    staticClass: "int_niv1"
  }, [_vm._v("8. The Christian use of Numbers")])]), _c('p', {
    staticClass: "txt_courant_ssalinea"
  }, [_c('a', {
    attrs: {
      "id": "page_55"
    }
  }, [_vm._v("The prime duty of every interpreter of Holy Scripture is the elucidation of the original meaning of the text. But from Paul onwards Christian expositors have recognized that there is more to interpretation than historico-grammatical exegesis: ‘whatever was written in former days was written for our instruction’ (Rom 15:4). The lessons of these ancient texts, must be re-applied to the problems of the church in later ages.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP41",
      "id": "ap_NBP41-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Our guide in relating the teaching of Numbers to the new covenant situation must be the New Testament; "), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("to this end I have usually included at the end of each chapter a few remarks about the relationship between the passage and later biblical revelation. Here I offer a brief overview of the use of Numbers in the New Testament, to help the modern reader gain spiritual profit as well as historical knowledge from his study of the book.")])]), _c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("For the writers of the New Testament the book of Numbers stands as a great warning. Despite the miraculous deliverance from Egypt, and the daily evidences of God’s provision for their needs, Israel refused to believe and rebelled against their Saviour. Numbers records a trail of spectacular judgments that ought to provoke caution in every believer.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("‘I want you to know, brethren, that our fathers were all under the cloud (cf. Num. 9:15–23), and all passed through the sea, and all were baptized into Moses in the cloud and in the sea (cf. Exod. 14:19–31; Num. 33:8), and all ate the same supernatural food (cf. Exod. 16:4ff.; Num. 11:4ff.) and all drank the same supernatural drink. For they drank from the supernatural Rock which followed them, and the Rock was Christ (cf. Exod. 17:1–7; Num. 20:2–13). Nevertheless with most of them God was not pleased; for they were overthrown in the wilderness’ (cf. Num. 14:28–35; 26:63–65).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("‘Now these are warnings for us, not to desire evil as they did. Do not be idolaters as some of them were; as it is written, “The people sat down to eat and drink and rose up to dance.” (Exod. 32:4–6). We must not indulge in immorality as some of them did, and twenty-three thousand fell in a single day (cf. Num. 25). We must not put the L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ORD ")]), _vm._v("to the test, as some of them did and were destroyed by serpents (cf. Num. 21:4–9); nor grumble, as some of them did and were destroyed by the Destroyer (cf. Num. 11:1ff.; 14:1ff.; 16:42ff.)’ (1 Cor. 10:1–10).")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_56"
    }
  }, [_vm._v("In this passage Paul describes the experiences of Israel in the wilderness in such a way as to make clear the parallels with the situation at Corinth.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP42",
      "id": "ap_NBP42-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" Most of the sins of Corinth are thus prefigured "), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("in Numbers, and if Israel was punished so severely, what can the church of the new covenant expect?")])]), _c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Similarly Hebrews reminds its readers of the spy incident. As disobedience and unbelief prevented the exodus generation from entering the promised land of rest, so the same sins can bar later generations from the enjoyment of a heavenly rest (Heb. 3:7 – 4:13). Jude too makes use of the stories in Numbers to warn the church of ever-present dangers from ungodly members. ‘I desire to remind you . . that he who saved a people out of the land of Egypt, afterward destroyed those who did not believe’ (Jude 5). He picks out immorality, the rejection of authority (Korah’s rebellion) and covetousness (Balaam’s error) as characteristic faults of these men (Jude 8, 11).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("If the epistles focus on Israel’s disobedience in the wilderness, the Gospels remind us of God’s gracious provision then and the more wonderful era ushered in by the coming of Christ. In the Synoptic Gospels Jesus is in a sense the new Israel who succeeded where the old Israel fell. After his baptism by John (cf. Paul’s association of baptism with the Red Sea crossing, 1 Cor. 10:2), he was driven into the wilderness and was hungry. His replies to the devil’s temptations are all drawn from passages in Deuteronomy dealing with Israel’s wilderness experiences (Matt. 4; Luke 4).")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("In John’s Gospel Jesus is portrayed as the prophet who is greater than Moses (6:14; cf. 5:46), the good shepherd (10:1–18; cf. Num. 27:17), the life-giving serpent (3:14), the passover Iamb (19:36), the water giver (4:10–15), the manna from heaven (6:26–58), and the glory of the Shekinah (1:14–18). In our Lord all the Old Testament symbols of the grace and presence of God find their ultimate fulfilment.")])]), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_57"
    }
  }, [_vm._v("These examples of the way Numbers is used by the New Testament writers all demonstrate the principle of typology, a principle already enunciated in Numbers itself as it presents the history of Israel in a series of cycles. Typology is a natural, if not an inevitable, technique of historical writing once the constancy of God’s character and human nature are understood. Though the light of revelation grows ever brighter with the passing of time, man’s ability to respond to truth is little altered. Thus against the changing background of historical development there will be repeated cycles of sin, grace and judgment. God’s ideals of holiness for Israel, the ")]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("priests or Moses will prefigure the only one who ever embodied those ideals perfectly, while the actual performance of Israel or her leaders will anticipate the real experience of the church and the ministers of the gospel in every age.")])]), _c('a', {
    attrs: {
      "id": "page_58"
    }
  }), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_c('a', {
    attrs: {
      "id": "page_58"
    }
  }, [_vm._v("The principle of typology may also be invoked to explain the relationship of the laws in Numbers to the Christian. But just as it is necessary to generalize to see the parallels between Moses and Christ or the church and Israel, so one must look behind the particular provisions of Numbers to the underlying principles if their validity and applicability in the Christian era are to be appreciated. Theologically and socially the modern church finds itself in a quite different situation from ancient Israel: this changed setting must be borne in mind when the ancient laws are interpreted.")]), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP43",
      "id": "ap_NBP43-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")])])]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Thus the institution of cities of refuge (Num. 35) is no longer appropriate in our society. First, because we leave the arrest of criminals to the police, not to the relatives of the murdered man, there is no need for a sanctuary for homicides. Secondly, it would be difficult to devise a punishment for manslaughter in our secular society like that of detention in the city of refuge until the high priest’s death, because there is no-one of comparable religious stature in our secular society. Even if the law is no longer applicable in detail, its underlying principle remains valid. The life of man, created in the image of God, is beyond price. Damages can never compensate for its loss. Traditional English and American law recognized this principle without creating cities of refuge,"), _c('sup', {
    staticClass: "footnote-out"
  }, [_c('span', {
    staticClass: "apnf",
    attrs: {
      "href": "#/appen7#NBP44",
      "id": "ap_NBP44-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" and it is this principle that should inform the Christian conscience, whatever the mores of the society he lives in.")]), _vm._v(" "), _c('p', {
    staticClass: "txt_courant_justif"
  }, [_vm._v("Similarly the sacrificial offerings of animals, flour, oil and wine prescribed in Numbers (7; 15; 28 – 29) are no longer valid expressions of Christian worship, because they point beyond themselves to the one atoning sacrifice of Christ which has made them obsolete (Heb. 10). Yet Christians are still reminded: ‘let us continually "), _c('a', {
    attrs: {
      "id": "page_59"
    }
  }, [_vm._v("offer up a sacrifice of praise to God, that is, the fruit of lips that acknowledge his name. Do not neglect to do good and to share what you have, for such sacrifices are pleasing to God’ (Heb. 13:15–16). The principle of whole-hearted dedication to the worship of God links Old and New Testaments, even if our mode of devotion has altered. Similarly if the tithe (Num. 18) remains a norm for Christian giving (Matt. 23:23), it may be noted that some believers evidently gave much more (Luke 19:8; Acts 2:45; 2 Cor. 8). If much of the biblical legislation cannot be applied today, its thoroughness and attention to detail should challenge the modern church to ask whether our more casual attitudes may not be a cloak for indifference.")])]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  })]), _c('a', {
    attrs: {
      "id": "page_59"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-30fb2ae4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pre5.vue
// module id = 75
// module chunks = 0